import { render, staticRenderFns } from "./StartCourse.vue?vue&type=template&id=55fe3fd6&scoped=true&"
import script from "./StartCourse.vue?vue&type=script&lang=js&"
export * from "./StartCourse.vue?vue&type=script&lang=js&"
import style0 from "./StartCourse.vue?vue&type=style&index=0&id=55fe3fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe3fd6",
  null
  
)

export default component.exports